import * as React from "react";
import { SVGProps } from "react";
export const CalendarPencilIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M4.16667 18.3333C3.70833 18.3333 3.31597 18.1701 2.98958 17.8437C2.66319 17.5173 2.5 17.125 2.5 16.6666V4.99996C2.5 4.54163 2.66319 4.14926 2.98958 3.82288C3.31597 3.49649 3.70833 3.33329 4.16667 3.33329H5V1.66663H6.66667V3.33329H13.3333V1.66663H15V3.33329H15.8333C16.2917 3.33329 16.684 3.49649 17.0104 3.82288C17.3368 4.14926 17.5 4.54163 17.5 4.99996V9.16663H15.8333V8.33329H4.16667V16.6666H10V18.3333H4.16667ZM4.16667 6.66663H15.8333V4.99996H4.16667V6.66663ZM11.6667 18.3333V15.7708L16.2708 11.1875C16.3958 11.0625 16.5347 10.9722 16.6875 10.9166C16.8403 10.8611 16.9931 10.8333 17.1458 10.8333C17.3125 10.8333 17.4722 10.8645 17.625 10.927C17.7778 10.9895 17.9167 11.0833 18.0417 11.2083L18.8125 11.9791C18.9236 12.1041 19.0104 12.243 19.0729 12.3958C19.1354 12.5486 19.1667 12.7013 19.1667 12.8541C19.1667 13.0069 19.1389 13.1632 19.0833 13.3229C19.0278 13.4826 18.9375 13.625 18.8125 13.75L14.2292 18.3333H11.6667ZM12.9167 17.0833H13.7083L16.2292 14.5416L15.8542 14.1458L15.4583 13.7708L12.9167 16.2916V17.0833ZM15.8542 14.1458L15.4583 13.7708L16.2292 14.5416L15.8542 14.1458Z"
            fill="currentColor"
        />
    </svg>
);
CalendarPencilIcon.displayName = "CalendarPencilIcon";
